export default __webpack_public_path__ + "static/1207-bd632af9f1ffeffbdcc196bfa2d3386d.gif";